import * as API from '~/domain/api';

export default class AuthPermission implements API.AuthPermission {
  private _id: number;
  private _permissionName: string;
  private _accounts: any[];

  constructor(json: API.AuthPermission) {
    this._id = json.permissionId ?? json.id ?? 0;
    this._accounts = json.accounts;
    this._permissionName = json.permissionName;
  }

  /**
   * Getter id
   * @return {number}
   */
  public get id(): number {
    return this._id;
  }

  /**
   * Setter id
   * @param {number} value
   */
  public set id(value: number) {
    this._id = value;
  }

  /**
   * Getter permissionName
   * @return {string}
   */
  public get permissionName(): string {
    return this._permissionName;
  }

  /**
   * Setter permissionName
   * @param {string} value
   */
  public set permissionName(value: string) {
    this._permissionName = value;
  }

  /**
   * Getter accounts
   * @return {any[]}
   */
  public get accounts(): any[] {
    return this._accounts.length > 0 ? this._accounts : [];
  }

  /**
   * Setter accounts
   * @param {any[]} value
   */
  public set accounts(value: any[]) {
    this._accounts = value;
  }
}
